import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { LitterGrid } from "./LitterGrid";

export const UpcomingLittersHome = ({ lang }) => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const load = useCallback(() => { api.get("/litters/browse?per_page=4").then((r) => setItems(r.data.items)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load, user?.user_id]);
  if (!items.length) return null;
  const fr = lang === "fr";
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-testid="home-upcoming-litters">
      <div className="flex items-end justify-between mb-6 gap-4">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#12234A]">{fr ? "Portées à venir" : "Upcoming litters"}</h2>
          <p className="text-slate-500 mt-1">{fr ? "Réservez votre place auprès d'éleveurs avant l'arrivée des bébés." : "Get on a breeder's waitlist before the babies arrive."}</p>
        </div>
        <Link to="/litters" data-testid="home-litters-see-all" className="text-[#F5551E] font-semibold flex items-center gap-1 hover:gap-2 transition-all shrink-0">
          {fr ? "Tout voir" : "See all"} <ArrowRight size={18} />
        </Link>
      </div>
      <LitterGrid items={items} onChanged={load} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" />
    </section>
  );
};
